import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login.component';
import {AuthGuardfor} from '../service/authGuard.service';
import {SsoRestrictGuard} from '../service/ssoRestrict.guard';
import {SsoLoginBlockGuard} from '../service/ssoLoginBlock.guard';
import {SsoEmailTokenGuard} from '../service/ssoEmailToken.guard';


const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    canActivate: [SsoLoginBlockGuard]
  },
  {
    path: 'registration',
    loadChildren: '../registration/registration.module#RegistrationModule',
  },
  
  {
    path: 'forget-password/:id',
    loadChildren: '../forget-password/forget-password.module#ForgetPasswordModule',
  },
  {
    path:'home',
    loadChildren: '../home/home.module#HomeModule' ,canActivateChild:[SsoEmailTokenGuard, AuthGuardfor, SsoRestrictGuard],
  },
        
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule {
  constructor(){
  }
 }